/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdershippingPendrivesEditDialog extends Common.GridEditorDialog<OrdershippingPendrivesRow> {
        protected getFormKey() { return OrdershippingPendrivesForm.formKey; }
        protected getLocalTextPrefix() { return OrdershippingPendrivesRow.localTextPrefix; }

        protected form: OrdershippingPendrivesForm;
        public maxMark: number;
        public vOrderId: number;
        constructor() {
            super();
            //
            this.form = new OrdershippingPendrivesForm(this.idPrefix);

            //this.form.ProductId.changeSelect2(e => {
            //    try {
            //        debugger;
            //        var strudentId = this.form.ProductId.value;
            //        //var ProductId = this.form.ProductId.value;
            //        if (parseInt(strudentId) == 0) {
            //            //this.setProductDetails({});
            //            return;
            //        }
            //        else {
            //            debugger;

            //            var productName = Q.first(Products.ProductsRow.getLookup().items, x => x.ProductId == Number(strudentId)).ProductName;
            //            this.form.ProductProductName.value = productName.toString();
            //        }
            //    } catch (e) {
            //        alert(e.message);
            //        debugger;
            //    }
            //});
            
           
        }
        loadEntity(entity: OrdershippingPendrivesRow) {
            super.loadEntity(entity);
            if (this.isNewOrDeleted) {
                this.form.OrderId.value = this.vOrderId.toString();
                Serenity.EditorUtils.setReadonly(this.form.OrderId.element, true);
            }
            else {
                Serenity.EditorUtils.setReadonly(this.form.OrderId.element, true);
            }
        }
    }
}